import {Divider, Flex, String} from "@hps/hops-react";

import CheckoutDiscountsUiInput from "./CheckoutDiscountsUiInput.js";
import CheckoutDiscountsUiList from "./CheckoutDiscountsUiList.js";

export default () => {

	return (
		<Flex
			fullWidth={true}>
			<Divider />
			<String
				bold={true}
				noFlex={true}
				str="Discount Codes" />
			<CheckoutDiscountsUiList />
			<CheckoutDiscountsUiInput />
		</Flex>
	);

};
